import { json2csvAsync } from 'json-2-csv'
import { csvToBlob, safeExcelValue, triggerFileDownload, withUtf8Bom } from '@/utils/export'

const sanitizeCsvRow = (row) => {
    return Object.fromEntries(Object.entries(row || {}).map(([key, value]) => [key, safeExcelValue(value)]))
}

export function useCsvExport() {
    const downloadAsCsv = async (rows, filename = 'export') => {
        try {
            const safeRows = Array.isArray(rows) ? rows.map(sanitizeCsvRow) : []
            const columns = []

            safeRows.forEach((row) => {
                Object.keys(row).forEach((key) => {
                    if (!columns.includes(key)) {
                        columns.push(key)
                    }
                })
            })

            const csvRows = safeRows.map((row) =>
                Object.fromEntries(columns.map((column, index) => [`column_${index}`, row[column] ?? ''])),
            )
            const keys = columns.map((column, index) => ({
                field: `column_${index}`,
                title: column,
            }))
            const csvContent = await json2csvAsync(csvRows, keys.length ? { keys } : undefined)
            const blob = csvToBlob(withUtf8Bom(csvContent))
            const fileName = filename.endsWith('.csv') ? filename : `${filename}.csv`

            triggerFileDownload(blob, fileName)
            return true
        } catch (error) {
            console.error('Failed to export CSV:', error)
            return false
        }
    }

    return {
        downloadAsCsv,
    }
}
